/*
Copyright (c) 2021
*/

import constants from '../../constants';

const {
  REQUEST_ENDINTERVIEW,
  ENDINTERVIEW_RECEIVED,

} = constants.EndInterviewConstant;

export default {
  REQUEST_ENDINTERVIEW,
  ENDINTERVIEW_RECEIVED,


  requestEndInterview: payload => ({
    type: REQUEST_ENDINTERVIEW,
    payload
  }),
  EndtInterviewReceived: () => ({
    type: ENDINTERVIEW_RECEIVED
  }),


};
